import { useState } from 'react';
import { cn } from '@/lib/cn';
import type { ChatMessage } from '@shared/types/api';

export function PinnedBar({
  messages,
  onJumpTo,
  onUnpin,
}: {
  messages: ChatMessage[];
  onJumpTo: (id: string) => void;
  onUnpin: (id: string) => void;
}) {
  const [expanded, setExpanded] = useState(false);
  if (messages.length === 0) return null;

  const head = messages[0];
  const hasMore = messages.length > 1;

  return (
    <div className="border-b border-gray-200 bg-amber-50/60">
      <div className="mx-auto flex max-w-3xl items-center gap-3 px-5 py-2">
        <span className="text-xs font-semibold uppercase text-amber-800">📌 Pinned</span>
        <button
          type="button"
          onClick={() => onJumpTo(head.id)}
          className="flex-1 truncate text-left text-sm text-gray-700 hover:text-gray-900"
        >
          {head.body ?? '(attachment)'}
        </button>
        {hasMore ? (
          <button
            type="button"
            onClick={() => setExpanded((v) => !v)}
            className="text-xs text-amber-800 hover:underline"
          >
            {expanded ? 'Hide' : `${messages.length - 1} more`}
          </button>
        ) : null}
      </div>
      {expanded ? (
        <ul className="border-t border-amber-100 bg-amber-50/40">
          {messages.slice(1).map((m) => (
            <li key={m.id} className="flex items-center gap-2 px-5 py-1.5 text-xs">
              <button
                type="button"
                onClick={() => onJumpTo(m.id)}
                className={cn('flex-1 truncate text-left text-gray-700 hover:text-gray-900')}
              >
                {m.body ?? '(attachment)'}
              </button>
              <button
                type="button"
                onClick={() => onUnpin(m.id)}
                className="text-amber-800 hover:underline"
              >
                Unpin
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
